// extracted by mini-css-extract-plugin
export var active = "_el-2";
export var recordingDot = "_el-1";
export var recordingIndicator = "_el-0";